export default "__VITE_ASSET__bd58346b__"